import { LogoMark } from "./LogoMark";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold/15 bg-ink-soft/60">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-14">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
        <div className="flex items-center gap-4">
          <LogoMark size={44} />
          <div>
            <p className="font-serif text-xl text-sand">
              Dott. Andrea <span className="italic text-gold">Moretti</span>
            </p>
            <p className="text-xs text-sand-faint mt-1">
              Psicologo · Psicoterapeuta in formazione a indirizzo junghiano (CIPA)
            </p>
          </div>
        </div>
        <div className="text-sm text-sand-muted leading-relaxed">
          <p>Corso Trapani 150 — 10141 Torino</p>
          <p className="mt-1">Iscritto all'Albo degli Psicologi del Lazio dal 2021</p>
          <p className="mt-1">Membro del Centro Clinico Psicoanalitico Forbas</p>
        </div>
      </div>
      <div className="mt-10 pt-8 border-t border-gold/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-sand-faint">
        <p>© {new Date().getFullYear()} Dott. Andrea Moretti — Tutti i diritti riservati</p>
        <p className="font-cormorant italic text-sm text-sand-faint/80">
          «Chi guarda fuori sogna, chi guarda dentro si sveglia.» — C. G. Jung
        </p>
      </div>
    </div>
  </footer>
);
